module.exports = __webpack_public_path__ + "img/sec3desk.fa839983.png";